export { default } from './support-v2-form-page';
